// extracted by mini-css-extract-plugin
export default {"gift":"Gifts_gift__Rsd0N","giftFooter":"Gifts_giftFooter__WruQN"};